<template>
    <div>
        <!-- Header Card -->
        <b-row class="mb-4">
            <b-col md="12">
                <b-card text-variant="center">
                    <h1 class="text-primary mb-2">
                        Premium Link Generator {{ hostDisplay }}
                    </h1>
                    <!-- Host-specific intro for SEO -->
                    <b-card-text class="mb-2 text-dark">
                        Use our Premium Link Generator for {{ hostDisplay }} to
                        download files with no ads, no waiting, and multi-thread
                        support.
                    </b-card-text>
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="warning"
                        @click="$router.push({ name: 'plans' })"
                    >
                        Check Plans
                    </b-button>
                </b-card>
            </b-col>
        </b-row>

        <!-- Features -->
        <b-row class="mt-3">
            <!-- Card 1: No Ads & No Waiting -->
            <b-col md="4">
                <b-card>
                    <b-avatar variant="primary" size="50" class="shadow mb-2">
                        <feather-icon size="28" icon="ZapIcon" />
                    </b-avatar>
                    <h2 class="text-primary mb-1">No Ads & No Waiting</h2>
                    <b-card-text>
                        Enjoy instant downloads without annoying ads or waiting
                        times.
                    </b-card-text>
                </b-card>
            </b-col>

            <!-- Card 2: Multithread Downloads -->
            <b-col md="4">
                <b-card>
                    <b-avatar variant="primary" size="50" class="shadow mb-2">
                        <feather-icon size="28" icon="LayersIcon" />
                    </b-avatar>
                    <h2 class="text-primary mb-1">Multithread Downloads</h2>
                    <b-card-text>
                        Boost your downloads speed using multiple threads.
                    </b-card-text>
                </b-card>
            </b-col>

            <!-- Card 3: Prices -->
            <b-col md="4">
                <b-card>
                    <b-avatar variant="primary" size="50" class="shadow mb-2">
                        <feather-icon size="28" icon="DollarSignIcon" />
                    </b-avatar>
                    <h2 class="text-primary mb-1">Prices</h2>
                    <b-card-text>
                        A lower price than the majority of file hosters while
                        still offering more features and hosters.
                    </b-card-text>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { BAvatar, BCol, BRow, BCard, BCardText, BButton } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

export default {
    name: "PremiumLinkGenerator",
    components: { BCol, BRow, BCard, BCardText, BButton, BAvatar },
    directives: { Ripple },
    data() {
        return { hostName: "" };
    },
    computed: {
        hostDisplay() {
            if (!this.hostName) return "";
            return (
                this.hostName.charAt(0).toUpperCase() + this.hostName.slice(1)
            );
        },
    },
    mounted() {
        this.setHost();
    },
    watch: {
        "$route.params.host"(newHost) {
            this.setHost();
        },
    },
    methods: {
        setHost() {
            this.hostName = this.$route.params.host;
            const capitalized = this.hostDisplay;

            // SEO: title
            document.title = `${capitalized} - Premium Link Generator | Leechall.io`;

            // SEO: description
            const description = `${capitalized} premium link generator. Download files from ${capitalized} with fast access, no ads, and a simple download experience.`;
            let descTag = document.querySelector('meta[name="description"]');
            if (!descTag) {
                descTag = document.createElement("meta");
                descTag.setAttribute("name", "description");
                document.head.appendChild(descTag);
            }
            descTag.setAttribute("content", description);

            // SEO: keywords
            const keywords = `${capitalized} premium link generator, ${capitalized} download, ${capitalized} file host, premium ${capitalized}, leechall`;
            let keywordsTag = document.querySelector('meta[name="keywords"]');
            if (!keywordsTag) {
                keywordsTag = document.createElement("meta");
                keywordsTag.setAttribute("name", "keywords");
                document.head.appendChild(keywordsTag);
            }
            keywordsTag.setAttribute("content", keywords);

            // Open Graph
            const ogMap = [
                {
                    property: "og:url",
                    content: `https://leechall.io/premium-link-generator/${this.hostName}`,
                },
                {
                    property: "og:title",
                    content: `Premium Link Generator ${capitalized} - Leechall.io`,
                },
                { property: "og:description", content: description },
                {
                    property: "og:image",
                    content: "https://leechall.io/logo.png",
                },
            ];

            ogMap.forEach(({ property, content }) => {
                let tag = document.querySelector(
                    `meta[property="${property}"]`
                );
                if (!tag) {
                    tag = document.createElement("meta");
                    tag.setAttribute("property", property);
                    document.head.appendChild(tag);
                }
                tag.setAttribute("content", content);
            });

            // Twitter Card
            const twitterMap = [
                {
                    name: "twitter:title",
                    content: `Premium Link Generator ${capitalized} - Leechall.io`,
                },
                { name: "twitter:description", content: description },
                {
                    name: "twitter:url",
                    content: `https://leechall.io/premium-link-generator/${this.hostName}`,
                },
                {
                    name: "twitter:image",
                    content: "https://leechall.io/logo.png",
                },
            ];

            twitterMap.forEach(({ name, content }) => {
                let tag = document.querySelector(`meta[name="${name}"]`);
                if (!tag) {
                    tag = document.createElement("meta");
                    tag.setAttribute("name", name);
                    document.head.appendChild(tag);
                }
                tag.setAttribute("content", content);
            });
        },
    },
};
</script>

<style scoped>
ul li {
    margin-bottom: 4px;
}
</style>
